<script>
import { mapActions } from 'vuex'

export default {
  name: 'PortNameForm',
  props: {
    form: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions('portName', [
      'getPortNames',
      'createPortName',
      'editPortName',
    ]),
    addPortName(evt) {
      evt.target.disabled = true
      this.createPortName(this.form)
        .then((resp) => {
          if (resp.status === 201) {
            this.$store.commit('portName/CREATE_PORT_NAME', resp.data)
            let notification = {
              id: Date.now(),
              title: 'CREATE',
              type: 'success',
              message: 'The port name has been created',
            }
            this.$store.dispatch('notification/addNotification', notification, {
              root: true,
            })
            this.$parent.form = {}
            this.getPortNames()
          }
        })
        .finally((evt.target.disabled = false))
    },
    updatePortName(evt) {
      evt.target.disabled = true
      this.editPortName(this.form)
        .then((resp) => {
          if (resp.status === 200) {
            this.$store.commit('portName/UPDATE_PORT_NAME', resp.data)
            let notification = {
              id: Date.now(),
              title: 'UPDATE',
              type: 'success',
              message: 'The port name has been updated',
            }
            this.$store.dispatch('notification/addNotification', notification, {
              root: true,
            })
            this.$parent.form = {}
          }
        })
        .finally((evt.target.disabled = false))
    },
  },
}
</script>
<template>
  <div class="col card">
    <form id="port-name-form" class="form-inline mt-3 mb-4">
      <label class="m-2">Name</label>
      <input
        v-model="form.name"
        placeholder="Name"
        class="form-control m-2"
        type="text"
      />

      <label class="m-2">Number</label>
      <input
        v-model="form.portNumber"
        placeholder="Number"
        class="form-control m-2"
        type="number"
      />

      <label class="m-2">Email</label>
      <input
        v-model="form.email"
        placeholder="Email"
        class="form-control m-2"
        type="email"
      />

      <label class="m-2">Description</label>
      <input
        v-model="form.description"
        placeholder="Description"
        class="form-control col-2 p-2 m-0"
        type="text"
      />

      <button
        v-if="form.id"
        type="submit"
        name="submit"
        class="btn btn-primary m-2"
        @click.prevent="updatePortName"
        >Update</button
      >
      <button
        v-else
        type="submit"
        name="submit"
        class="btn btn-primary m-2"
        @click.prevent="addPortName"
        >Add</button
      >
    </form>
  </div>
</template>
